
import React from 'react';

import Feature from'./Feature/Feature'
import Banner from'./Banner/Banner.jsx'
import Chanel from './chanel/Channel'
const Dashboard = () => {
    return (
        <div style={{backgroundColor:'rgba(245, 245, 255, 1)'}}>
            <Banner/>
            <Feature/>
            <Chanel/>
        </div>
    );
};

export default Dashboard;